module.exports = "/images/close_x.svg?b0ad3c413f9d0d388afc9a267c239f65";